<template lang="html">
  <div class="edit-company">
    <Overlay
      width="x-small"
      :autoHeight="true"
      >

      <Notification
        v-if="notification.active"
        :withinOverlay="true"
        :content="notification.content"
        :type="notification.type"/>

      <CompanyForm
        :users="userOptions"
        @submit="submitCompany"
        v-model="company"
      />
    </Overlay>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {readCompanyData, updateCompanyData} from '@/lib/companies'
import {readCompanyUsersData} from '@/lib/company_users'

import Overlay from '@/components/Overlay'
import CompanyForm from '@/components/forms/CompanyForm'

export default {
  name: 'EditCompany',

  mixins: [page, notification],

  components: {
    Overlay,
    CompanyForm
  },

  props: {
    companyId: String,
    siteId: String
  },

  data() {
    return {
      company: {},
      users: [],
      errors: {}
    }
  },

  computed: {
    owner() {
      return this.company.owner || {}
    },

    companyUsers() {
      const out = this.users

      // add current owner to list if they arent already there
      if (
        !out.find((user) => {
          return user.id === this.owner.id
        })
      ) {
        out.push(this.owner)
      }

      return out
    },

    userOptions() {
      return this.users.map((user) => {
        const key = user.email
        const value = user.id

        return {key, value}
      })
    },

    title() {
      return `Editing ${this.company.name}`
    }
  },

  methods: {
    submitCompany() {
      updateCompanyData(this.companyId, this.company)
        .then(({data}) => {
          this.triggerNotification('success', 'company', 'updated')

          window.setTimeout(() => {
            this.$router.push({name: 'websites', params: {companyId: data.id}})
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanyUsersData(this.companyId, {page_size: 1000}).then(({data}) => {
        this.users = data
      })

      readCompanyData(this.companyId).then(({data}) => {
        this.company = data
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
